import { render, staticRenderFns } from "./recipeInfo.vue?vue&type=template&id=1e6f0cb7&scoped=true&"
import script from "./recipeInfo.vue?vue&type=script&lang=js&"
export * from "./recipeInfo.vue?vue&type=script&lang=js&"
import style0 from "./recipeInfo.vue?vue&type=style&index=0&id=1e6f0cb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6f0cb7",
  null
  
)

export default component.exports